import { combineReducers } from "redux";

//include providers
import traceProperties from "./traceProperties";

const reducer = combineReducers({
    traceProperties
})

export default reducer;